<pxc-paginated-list>
  @for (section of collection$ | async; track section.label) {
    <section class="py-3">
      @if (section.label) {
        <div class="sticky top-[106px] z-10 flex h-12 items-center bg-linear-to-b from-background-primary-alt">
          <p class="text-base font-medium text-text-tertiary">{{ section.label }}</p>
        </div>
      }

      <div class="grid gap-x-5 gap-y-4 py-1 lg:grid-cols-2 2xl:grid-cols-3">
        @for (patient of section.data; track patient.id) {
          <pxc-patient-card
            class="cursor-pointer px-[2px] animate-in fade-in slide-in-from-top-1 hover:[&>pxc-card-details]:bg-background-primary-hover"
            data-testid="patient-card"
            [actions]="actions"
            [patient]="patient"
            [patientLink]="patient.id">
            <pxc-patient-link-quick-action *showIfClientIsGamEnabled="patient" />
            @if (patient.isArchived) {
              <pxc-archived-badge class="ml-1" />
            }
          </pxc-patient-card>
        }
      </div>
    </section>
  } @empty {
    <pxc-lottie-label
      *transloco="let t"
      animation="patientEmpty"
      class="col-span-full"
      data-testid="no-patient-message"
      [message]="t('Vous n\'avez aucun patient')" />
  }
</pxc-paginated-list>
